module.exports = __webpack_public_path__ + "static/media/edresult3.45aefed5.png";